export const CONVERSATION_LAYOUT = Object.freeze({
  CLASSIC: 'classic',
  SIMPLIFIED: 'simplified',
});

const VALID_LAYOUTS = Object.values(CONVERSATION_LAYOUT);

export const normalizeConversationLayoutVersion = value => {
  return VALID_LAYOUTS.includes(value) ? value : CONVERSATION_LAYOUT.CLASSIC;
};

export const shouldHideResolvedByDefault = ({
  conversationViewMode,
  status,
} = {}) => {
  return (
    normalizeConversationLayoutVersion(conversationViewMode) ===
      CONVERSATION_LAYOUT.SIMPLIFIED &&
    (!status || status === 'all')
  );
};
